import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _possibleConstructorReturn from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _inherits from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.map.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import BaseModel from "./BaseModel";
import capitalize from "../utils/capitalize";
import { arrayUniqueByKey } from "../utils/unique";
import CustomerPhone from "./CustomerPhone";
import CustomerEmail from "./CustomerEmail";
var Customer = /*#__PURE__*/function (_BaseModel) {
  function Customer() {
    _classCallCheck(this, Customer);
    return _callSuper(this, Customer, arguments);
  }
  _inherits(Customer, _BaseModel);
  return _createClass(Customer, [{
    key: "fullName",
    value: function fullName() {
      return this.get('title') + ' ' + this.get('first_name') + ' ' + this.get('last_name');
    }
  }, {
    key: "maritalStatus",
    value: function maritalStatus() {
      return capitalize(this.get('marital_status'));
    }
  }, {
    key: "dependants",
    value: function dependants() {
      var val = Number(this.get('dependants'));
      return val > 0 ? val : 'None';
    }
  }, {
    key: "currentAddress",
    value: function currentAddress() {
      return this.get('addresses').find(function (a) {
        return a.is_current;
      });
    }
  }, {
    key: "phones",
    value: function phones() {
      return arrayUniqueByKey(this.get('phones'), 'number').map(function (phone) {
        return new CustomerPhone(phone);
      });
    }
  }, {
    key: "emails",
    value: function emails() {
      return arrayUniqueByKey(this.get('emails'), 'address').map(function (email) {
        return new CustomerEmail(email);
      });
    }
  }]);
}(BaseModel);
export default Customer;